import { isDemoMarket } from 'src/utils/functions';
import { UserIntent } from '../types';

export const detectUserIntent = (): UserIntent => {
  const currentUrl = window.location.pathname;

  // Specific market detection
  if (currentUrl.includes('/airbnb-data/') && !isDemoMarket()) {
    return {
      intent: 'explore_markets',
      context: { landingPage: currentUrl },
      skipOnboarding: true,
    };
  }

  // Calculator detection
  if (currentUrl.includes('/airbnb-calculator')) {
    return {
      intent: 'analyze_property',
      context: { landingPage: currentUrl },
      skipOnboarding: true,
    };
  }

  // Best markets
  if (currentUrl.includes('/markets/compare')) {
    return {
      intent: 'compare_markets',
      context: { landingPage: currentUrl },
      skipOnboarding: true,
    };
  }

  // Property search
  if (currentUrl.includes('/listing/')) {
    return {
      intent: 'analyze_market',
      context: { landingPage: currentUrl },
      skipOnboarding: true,
    };
  }

  return { intent: 'unclassified', context: { landingPage: '' }, skipOnboarding: false };
};
